import React, { ReactNode } from "react";
import { IonContent, IonHeader, IonPage, IonToolbar } from "@ionic/react";
import BottomTabNavigation from "./BottomTabNavigation";
import Header from "./Header";

interface TopBottomLayoutProps {
  children: ReactNode;
}

export default function TopBottomLayout({ children }: TopBottomLayoutProps) {
  return (
    <IonPage className="custom-page">
      <IonHeader className="custom-header">
        <IonToolbar className="custom-toolbar">
          <Header />
        </IonToolbar>
      </IonHeader>
      <IonContent forceOverscroll={false} fullscreen scrollEvents className="custom-content">
        {children}
      </IonContent>
      <BottomTabNavigation />
    </IonPage>
  );
}
